"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var sceneSorting = __importStar(require("./scenes"));
var utils_1 = require("./utils");
var SceneSorter = /** @class */ (function () {
    function SceneSorter(props) {
        var _this = this;
        this.compare = function (a, b) {
            var compareFn = _this.sortOptions[_this.sortBy];
            var comp = compareFn ? compareFn(a, b) : 0;
            if (_this.sortOrder === 'desc') {
                return comp * -1;
            }
            return comp;
        };
        this.compareShootDates = function (a, b) {
            var momentCompare = utils_1.dateCompare(a.shoot_day, b.shoot_day);
            if (momentCompare) {
                return momentCompare;
            }
            return _this.compareScenes(a, b);
        };
        this.compareScenes = function (a, b) {
            var epResult = _this.compareEpisodes(a, b);
            if (epResult) {
                return epResult;
            }
            var result = sceneSorting.compareScenes(a, b, _this.alpha);
            if (result) {
                return result;
            }
            else {
                return utils_1.dateCompare(a.shoot_day, b.shoot_day);
            }
        };
        this.compareEpisodes = function (a, b) {
            var aProd = _this.productions.find(function (p) { return p.id === a.prod_id || p.api_id === a.prod_id; });
            var bProd = _this.productions.find(function (p) { return p.id === b.prod_id || p.api_id === b.prod_id; });
            return utils_1.prodCompare(aProd, bProd);
        };
        this.compareScriptDates = function (a, b) {
            var cmp = utils_1.compareLetterFirst(sceneSorting.decodeScriptDayForSort(a).script_day, sceneSorting.decodeScriptDayForSort(b).script_day);
            if (!cmp) {
                if (a.shoot_time == b.shoot_time) {
                    sceneSorting.compareScenes(a, b, _this.alpha);
                }
                else if (a.shoot_time === 3 || b.shoot_time === 3) {
                    if (a.shoot_time !== 3) {
                        return 1;
                    }
                    else if (b.shoot_time !== 3) {
                        return -1;
                    }
                }
                else if (a.shoot_time === 1 || b.shoot_time === 1) {
                    if (a.shoot_time !== 1) {
                        return 1;
                    }
                    else if (b.shoot_time !== 1) {
                        return -1;
                    }
                }
                else if (a.shoot_time === 4 || b.shoot_time === 4) {
                    if (a.shoot_time !== 4) {
                        return 1;
                    }
                    else if (b.shoot_time !== 4) {
                        return -1;
                    }
                }
                else {
                    if (a.shoot_time <= 0) {
                        return 1;
                    }
                    else if (b.shoot_time <= 0) {
                        return -1;
                    }
                }
            }
            return cmp;
        };
        this.scenes = props.scenes;
        this.productions = props.productions;
        this.sortBy = props.sortBy;
        this.sortOrder = props.sortOrder;
        this.alpha = props.alpha;
        this.sortOptions = __assign({ name: this.compareScenes, shoot_day: this.compareShootDates, prod_id: this.compareScenes, script_date: this.compareScriptDates }, props.sortOptions);
    }
    SceneSorter.prototype.sort = function () {
        return this.scenes.sort(this.compare);
    };
    return SceneSorter;
}());
exports.SceneSorter = SceneSorter;
